import React, { useEffect, useState, useMemo } from "react";
import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";

const MonthWiseToGraph = ({ data }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (!data || data.length === 0) {
      setChartData(null);
      return;
    }

    const years = [...new Set(data.map((o) => o.F_YEAR))];
    const dimensions = ["product", ...years];

    const series = Object.values(
      data.reduce((acc, item) => {
        const product = item.EX;
        const year = item.F_YEAR;

        if (!acc[product]) {
          acc[product] = { product, _total: 0 };
          years.forEach((y) => (acc[product][y] = 0));
        }

        acc[product][year] += 1;
        acc[product]._total += 1;

        return acc;
      }, {})
    )

      .sort((a, b) => b._total - a._total)
      .map(({ _total, ...rest }) => rest);

    setChartData({
      dimensions,
      series,
    });
  }, [data]);

  return (
    <div>
      <h6 className="m-1 p-2 bg-dark text-white">EX Wise HO Graph </h6>
      <hr className="m-1 p-0" />
      {chartData ? (
        <GroupedBarChart data={chartData} from="LongHaul" chartType="bar" />
      ) : (
        "No Data Found"
      )}
    </div>
  );
};

export default MonthWiseToGraph;
